const getCurrentSegmentFromUrl = (url: string | undefined) => {
    return url?.split("#")[0].split("?")[0].split("/").pop();
};

export default getCurrentSegmentFromUrl;
